// extracted by mini-css-extract-plugin
export var avatarContainer = "techstack-module--avatarContainer--iiiWG";
export var container = "techstack-module--container--nRV9J";
export var gridItem = "techstack-module--gridItem--wur8b";
export var img = "techstack-module--img--JRQ-m";
export var img2 = "techstack-module--img2--F7wMg";
export var textOverflow = "techstack-module--textOverflow--cBSxE";